import {useLayoutEffect, useRef, type FocusEvent, type RefObject} from 'react'

export function useTaskPinFocus(sidebarRef: RefObject<HTMLElement | null>, enabled: boolean) {
  const focusedTaskRef = useRef<{element: HTMLElement; taskId?: string; list?: HTMLElement} | null>(null)

  useLayoutEffect(() => {
    const focused = focusedTaskRef.current
    if (!enabled || !focused || focused.element.isConnected || document.activeElement !== document.body) return
    const sidebar = sidebarRef.current
    const list = focused.taskId
      ? sidebar
      : focused.list?.isConnected
        ? focused.list
        : sidebar?.querySelector<HTMLElement>('[data-task-pins-list]')
    if (sidebar?.querySelector('[data-task-pins-loading]')) return
    const nextRow = Array.from(list?.querySelectorAll<HTMLElement>('a[data-sidebar-pin-task-id]') ?? []).find(
      element =>
        (!focused.taskId || element.getAttribute('data-sidebar-pin-task-id') === focused.taskId) &&
        element.checkVisibility({checkVisibilityCSS: true}),
    )
    const target =
      nextRow ??
      list?.querySelector<HTMLElement>('[data-task-pins-retry]') ??
      sidebar?.querySelector<HTMLElement>('[data-task-pins-focus-target]')
    focusedTaskRef.current = null
    target?.focus()
  })

  return (event: FocusEvent<HTMLElement>) => {
    if (!enabled) return
    const taskId =
      event.target.closest<HTMLElement>('[data-sidebar-pin-task-id]')?.getAttribute('data-sidebar-pin-task-id') ??
      undefined
    if (taskId || event.target.closest('[data-task-pins-retry]')) {
      focusedTaskRef.current = {element: event.target, taskId, list: event.target.closest('ul') ?? undefined}
    } else if (event.currentTarget.contains(event.target)) focusedTaskRef.current = null
  }
}
